import React, { useContext, useState } from 'react';
import { SearchContext } from './SearchContext';
import CompetitionSearchForm from './CompetitionSearchForm';
import SolutionSearchForm from './SolutionSearchForm';
import CompetitionResults from './CompetitionResults';
import SolutionResults from './SolutionResults';
import './SearchContainer.css';

const SearchContainer: React.FC = () => {
  const searchContext = useContext(SearchContext);
  
  if (!searchContext) {
    return <div>検索コンテキストが初期化されていません</div>;
  }
  
  const {
    searchMode,
    setSearchMode,
    competitionQuery,
    setCompetitionQuery,
    solutionQuery,
    setSolutionQuery,
    competitionResults,
    solutionResults,
    similarityType,
    setSimilarityType,
    findSimilarCompetitions,
    performSearch,
    isLoading
  } = searchContext;
  
  const handleModeChange = (mode: 'competition' | 'solution') => {
    setSearchMode(mode);
  };
  
  return (
    <div className="search-container">
      <div className="search-mode-selector">
        <button 
          className={`mode-button ${searchMode === 'competition' ? 'active' : ''}`}
          onClick={() => handleModeChange('competition')}
        >
          コンペティション検索
        </button>
        <button 
          className={`mode-button ${searchMode === 'solution' ? 'active' : ''}`}
          onClick={() => handleModeChange('solution')}
        >
          ソリューション検索
        </button>
      </div>
      
      <div className="search-content">
        {searchMode === 'competition' ? (
          <CompetitionSearchForm 
            onSearch={setCompetitionQuery}
            onSimilarityTypeChange={setSimilarityType}
            selectedSimilarityType={similarityType}
            isLoading={isLoading}
          />
        ) : (
          <SolutionSearchForm 
            onSearch={setSolutionQuery}
            isLoading={isLoading}
          />
        )}
        
        <button 
          className="search-button"
          onClick={() => performSearch()}
          disabled={isLoading}
        >
          {isLoading ? '検索中...' : '検索実行'}
        </button>
        
        <div className="results-section">
          {searchMode === 'competition' ? (
            <CompetitionResults 
              competitions={competitionResults}
              onFindSimilar={findSimilarCompetitions}
              selectedSimilarityType={similarityType}
            />
          ) : (
            <SolutionResults 
              solutions={solutionResults}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchContainer;
